let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("20smI")).then(() => parcelRequire('cKzZa'));